export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/f97ac4fc4fe6d6a2e8c8d15703df054a.jpg)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white py-32">
        <div className="mb-6">
          <span className="inline-block text-orange-500 text-sm font-bold tracking-widest uppercase mb-4">
            Distribuzione Tecnologica B2B
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-6 leading-tight">
          Soluzioni Tecnologiche
          <span className="block italic font-serif text-orange-400">
            All&apos;Ingrosso
          </span>
          <span className="block">Per Professionisti</span>
        </h1>

        <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto text-gray-200 font-light">
          Partner affidabile per rivenditori e system integrator dal cuore della
          Campania
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <a
            href="#prodotti"
            className="group bg-orange-500 text-white px-10 py-5 rounded-xl text-lg font-bold hover:bg-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl hover:shadow-orange-500/50 hover:-translate-y-1 flex items-center space-x-3"
          >
            <span>Esplora Catalogo</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href="#chi-siamo"
            className="bg-transparent border-2 border-white text-white px-10 py-5 rounded-xl text-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl hover:-translate-y-1"
          >
            Scopri di Più
          </a>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#chi-siamo" className="w-12 h-12 flex items-center justify-center cursor-pointer">
          <i className="ri-arrow-down-line text-3xl text-white"></i>
        </a>
      </div>
    </section>
  );
}
